import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'roofA',
      d: 'M-2,-4.5h0.5v0.5h-0.5zM-4,-4h1.5v0.5h-1.5zM-2,-4h1v0.5h-1zM-4.5,-3.5h3.5v1h-3.5zM-4.5,-2.5h0.5v0.5h-0.5zM-2.5,-2.5h2v0.5h-2zM-4.5,-2h1v2h-1zM-1.5,-2h1v0.5h-1zM-1,-1.5h0.5v3h-0.5zM-4.5,0h0.5v0.5h-0.5zM-2.5,1h0.5v0.5h-0.5zM-1.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'firewoodLog',
      d: 'M4,-3h0.5v0.5h-0.5zM-3.5,-2.5h0.5v0.5h-0.5zM3.5,-2.5h1v1h-1zM-3.5,-2h1.5v0.5h-1.5zM2,-2h0.5v0.5h-0.5zM-3.5,-1.5h2v0.5h-2zM-0.5,-1.5h0.5v0.5h-0.5zM1.5,-1.5h3v1h-3zM-3.5,-1h1v0.5h-1zM-2,-1h1v1h-1zM-0.5,-1h1v0.5h-1zM-3.5,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h5v0.5h-5zM-3.5,0h2.5v1h-2.5zM-0.5,0h4.5v0.5h-4.5zM-0.5,0.5h3.5v0.5h-3.5zM-2,1h0.5v0.5h-0.5zM-0.5,1h2.5v0.5h-2.5zM-0.5,1.5h1.5v0.5h-1.5z',
    },
    { paint: 'roofB', d: 'M-3.5,-5h0.5v0.5h-0.5zM-4,-4.5h1v0.5h-1z' },
    {
      paint: 'ice',
      d: 'M-1,-4.5h1.5v0.5h-1.5zM3.5,-4.5h0.5v0.5h-0.5zM-1,-4h5.5v0.5h-5.5zM-1,-3.5h5v0.5h-5zM-0.5,-3h3v0.5h-3zM-0.5,-2.5h2v0.5h-2zM-0.5,-2h1v0.5h-1z',
    },
    {
      paint: 'snowCap',
      d: 'M-2.5,-7h0.5v0.5h-0.5zM-3.5,-6.5h3v0.5h-3zM-4,-6h5.5v0.5h-5.5zM-4.5,-5.5h7.5v0.5h-7.5zM-4.5,-5h0.5v1h-0.5zM-2,-5h5v0.5h-5zM0.5,-4.5h3v0.5h-3zM-5,-4h1v0.5h-1z',
    },
    {
      paint: 'bareBranch',
      d: 'M-3,-4.5h0.5v0.5h-0.5zM4,-3.5h1v0.5h-1zM3,-3h1v0.5h-1zM1.5,-2.5h1v0.5h-1zM0.5,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5z',
    },
    { paint: 'wall', d: 'M-2.5,-1h0.5v0.5h-0.5zM-3,-0.5h1v0.5h-1z' },
    {
      paint: 'wallShade',
      d: 'M-4,-5h0.5v0.5h-0.5zM-3,-5h1v0.5h-1zM3,-5h0.5v0.5h-0.5zM-5,-4.5h0.5v0.5h-0.5zM-1.5,-4.5h0.5v0.5h-0.5zM4,-4.5h0.5v0.5h-0.5zM4.5,-4h0.5v0.5h-0.5zM-1,-3h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM-4,-2.5h0.5v0.5h-0.5zM-3,-2.5h0.5v0.5h-0.5zM2.5,-2.5h1v1h-1zM-2,-2h0.5v0.5h-0.5zM1,-2h0.5v0.5h-0.5zM-1.5,-1.5h0.5v0.5h-0.5zM0.5,-1.5h1v1h-1zM-4,0h0.5v0.5h-0.5zM-1.5,1h0.5v0.5h-0.5z',
    },
    { paint: 'snowmanCoal', d: 'M-2.5,-4.5h0.5v1h-0.5z' },
  ],
  pixels: 259,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'roofA',
      d: 'M-2,-5.5h0.5v0.5h-0.5zM-3,-5h2v0.5h-2zM-4,-4.5h3v1h-3zM-4.5,-3.5h3.5v0.5h-3.5zM-4.5,-3h4v0.5h-4zM-4.5,-2.5h0.5v0.5h-0.5zM-2.5,-2.5h2v0.5h-2zM-4.5,-2h1v1h-1zM-1.5,-2h1v0.5h-1zM-1,-1.5h0.5v3h-0.5zM-4,-1h0.5v1h-0.5zM-2.5,1h0.5v0.5h-0.5zM-1.5,1.5h1v0.5h-1z',
    },
    {
      paint: 'firewoodLog',
      d: 'M-3.5,-2.5h0.5v0.5h-0.5zM3.5,-2.5h1v1h-1zM-3.5,-2h1.5v0.5h-1.5zM2,-2h0.5v0.5h-0.5zM-3.5,-1.5h2v0.5h-2zM-0.5,-1.5h0.5v0.5h-0.5zM1.5,-1.5h3v1h-3zM-3.5,-1h1v0.5h-1zM-2,-1h1v1h-1zM-0.5,-1h1v0.5h-1zM-3.5,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h5v0.5h-5zM-3.5,0h2.5v1h-2.5zM-0.5,0h4.5v0.5h-4.5zM-0.5,0.5h3.5v0.5h-3.5zM-2,1h0.5v0.5h-0.5zM-0.5,1h2.5v0.5h-2.5zM-0.5,1.5h1.5v0.5h-1.5z',
    },
    { paint: 'roofB', d: 'M-4,-6h1v1.5h-1zM-2,-6h0.5v0.5h-0.5z' },
    {
      paint: 'ice',
      d: 'M-1.5,-6h1v0.5h-1zM-1,-5.5h3.5v0.5h-3.5zM3.5,-5.5h0.5v0.5h-0.5zM-1,-5h5v0.5h-5zM-1,-4.5h5.5v0.5h-5.5zM-1,-4h6v0.5h-6zM-0.5,-3.5h4.5v0.5h-4.5zM-0.5,-3h3v0.5h-3zM-0.5,-2.5h2v0.5h-2zM0,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'snowCap',
      d: 'M-3,-8h2v0.5h-2zM-3.5,-7.5h4v0.5h-4zM-4.5,-7h7v0.5h-7zM-4.5,-6.5h7.5v0.5h-7.5zM-4.5,-6h0.5v1h-0.5zM-0.5,-6h4v0.5h-4zM2.5,-5.5h1v0.5h-1zM-5,-5h1v1h-1zM-5,-4h0.5v0.5h-0.5zM4,-3.5h0.5v0.5h-0.5zM3,-3h1v0.5h-1zM2,-2.5h1v0.5h-1zM1,-2h0.5v0.5h-0.5zM-5,-1h0.5v0.5h-0.5zM-5,-0.5h1v1h-1zM-4.5,0.5h1v0.5h-1z',
    },
    { paint: 'bareBranch', d: 'M-3,-6h0.5v1h-0.5zM0,-1.5h0.5v0.5h-0.5z' },
    { paint: 'wall', d: 'M-2.5,-1h0.5v0.5h-0.5zM-3,-0.5h1v0.5h-1z' },
    {
      paint: 'wallShade',
      d: 'M-1.5,-5.5h0.5v0.5h-0.5zM-4.5,-4h0.5v0.5h-0.5zM-1,-3.5h0.5v0.5h-0.5zM4.5,-3.5h0.5v0.5h-0.5zM2.5,-3h0.5v0.5h-0.5zM4,-3h0.5v0.5h-0.5zM-4,-2.5h0.5v0.5h-0.5zM-3,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v1h-0.5zM3,-2.5h0.5v0.5h-0.5zM-2,-2h0.5v0.5h-0.5zM-0.5,-2h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM2.5,-2h1v0.5h-1zM-1.5,-1.5h0.5v0.5h-0.5zM0.5,-1.5h1v1h-1zM-4.5,-1h0.5v0.5h-0.5zM-4,0h0.5v0.5h-0.5zM-1.5,1h0.5v0.5h-0.5z',
    },
    { paint: 'snowmanCoal', d: 'M-2.5,-6h0.5v1h-0.5z' },
  ],
  pixels: 307,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant0];
